import { createComponent } from '@lair-finance/util'
import { Button, ButtonProps } from '@/shared/ui/Button'
import { AgreementStorage } from '@/features/agreement/utils/storage.ts'
import { useResponsive } from '@/shared/hooks/useResponsive.ts'

export const AgreeButton = createComponent<HTMLButtonElement, ButtonProps>(({ onClick, ...props }, ref) => {
  const isTablet = useResponsive('tablet')
  const handleAgree = () => AgreementStorage.set(true)

  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    handleAgree()
    onClick?.(e)
  }

  return (
    <Button size={isTablet ? 'lg' : 'md'} onClick={handleClick} ref={ref} {...props}>
      Agree
    </Button>
  )
}, 'AgreeButton')
